import logo from '../assets/portfolio/my-logo.jpg'
import abugidaBanner from '../assets/portfolio/abugida.jpg'
import ha from '../assets/portfolio/ha-businesscard.jpg'
import ui from '../assets/portfolio/work1.jpg'
import web from '../assets/portfolio/web-design.jpg'
import packageDesign from '../assets/portfolio/work3.jpg'
import hijra from '../assets/portfolio/hijra-brochure.jpg'
import wed from '../assets/portfolio/wedding.jpg'


const portfolioData = [
  {
    title: 'Brand Identity Design',
    description: 'Complete brand identity design including logo, color palette, and typography for a new startup.',
    image: logo
  },
  {
    title: 'Product Packaging Design',
    description: 'Innovative packaging design for a new line of organic skincare products.',
    image: packageDesign,
  },
  {
    title: 'Invitation card Design',
    description: 'Breathtaking wedding invitation cards.',
    image: wed,
  },
  {
    title: 'Corporate Brochure Design',
    description: 'Professional and engaging corporate brochure designed for Hijra Bank.',
    image: hijra,
  },
  {
    title: 'Event Promotion',
    description: 'Visual design for promotional materials for a major tech conference.',
    image: abugidaBanner,
  },
  {
    title: 'Professional Business card',
    description: 'Custom business cards created for HA company.',
    image: ha,
  },
  {
    title: 'UI/UX Design',
    description: 'Modern and user-friendly website Design for food ordering web app.',
    image: ui,
  },
  {
    title: 'Responsive website Design',
    description: 'Responsive and visually appealing website design.',
    image: web,
  },
];

export default portfolioData;
